<template>
     <Forms ref="frmPermission"
            :title="title"
            :showHelp="true"
            :showClearButtonIcon="true"
            :ShowFooterImbo="true"
            :showSearchIcon="true"
            :showSearchButtonIcon="true"
            v-on:Clear="Clear"
            v-on:Search="Search"
            v-on:Load ="onLoad"
          >
        <div>
            <label class="labelseach mt-3">Empreendimento</label>
              <select v-model ="SearchItems.empreendimentoId" class="form-control" id="exampleFormControlSelect2">
                <option disabled selected  :value='""' >Selecione um empreendimento</option>
                <option v-for="data in consultaenterprise" v-bind:key="data.id" :value="data.id">{{data.nome}}</option>
              </select>

            <div class="d-flex align-items-end teste">
                <div id="form-cidade" class="d-flex align-content-start flex-wrap">
                 <label  class="labelseach mt-3" for="txtInsured">Cidade</label>
                  <autocomplete-z ref="CityEnterpriseTypeahead"
                    placeholder="Digite uma cidade"
                    :serializer="(cidade) => cidade.nome"
                    :debounceLength="3"
                    :formField="SearchItems.cidadeObj"
                    v-on:search="onSearchCityByNameEnterprise"
                    v-on:changeCode="onChangeCodeCityByNameEnterprise"
                    :ShowCode="false"
                      />
                </div>

                <div id="form-cidade" class="d-flex align-content-start flex-wrap">
                    <label class="labelseach mt-6">UF</label>
                    <select v-model ="SearchItems.estadoId" class="form-control" id="exampleFormControlSelect2">
                      <option disabled selected :value='""' >Selecione um UF</option>
                      <option v-for="data in consultastate" v-bind:key="data.id" :value="data.id">{{data.sigla}}</option>
                    </select>
                </div>
            </div>

            <label class="labelseach mt-3" for="txtInsured">Data Da Atualização</label>
            <p class="labeldate-ate">Desde</p>
            <div class="d-flex align-items-end">
                <b-form-datepicker
                v-model ="SearchItems.DataCadastroInicio"
                  placeholder="__/__/__"
                  locale="pt-BR"
                  today-button
                  label-today-button="Hoje"
                  reset-button
                  label-reset-button="Limpar"
                  close-button
                  label-close-button="Fechar"
                  :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                  ></b-form-datepicker>
            </div>
            <label class="margem labeldate-ate">Até</label>
            <div class="d-flex align-items-end">
                  <b-form-datepicker
                  v-model ="SearchItems.DataCadastroFim"
                  placeholder="__/__/__"
                  locale="pt-BR"
                  today-button
                  label-today-button="Hoje"
                  reset-button
                  label-reset-button="Limpar"
                  close-button
                  label-close-button="Fechar"
                  :date-format-options="{ year: '2-digit', month: 'numeric', day: 'numeric' }"
                  ></b-form-datepicker>
            </div>
          </div>
    </Forms>
</template>
<script>

import formPrice from './formPrice'
export default formPrice

</script>

<style scoped>
.margem{
  margin-top: 1rem;
}

.teste{
    gap: 30px
}
.labelseach{
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #666666;
  font-family: 'Segoe UI';
}
.labeldate-ate{
   margin-bottom: 3px;
   font-size: 14px;
   color: #666666;
    font-weight: bold;
   font-family: 'Segoe UI';
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/pricetablemanagement/components/formPrice/formPrice.vue